import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  disabledPopupIndicator: {
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  searchIcon: ({ isSearchEnabled }) => ({
    height: '0.75em',
    fill: isSearchEnabled ? theme.palette.primary.main : theme.palette.text.disabled,
  }),
  arrowIcon: {
    width: '0.6em',
    fill: theme.palette.tertiary.lightGreen,
  },
  searchContainer: {
    minHeight: '76px',
  },
}))

export default useStyles
